import { useEffect } from 'react';
import { Form, Input, InputNumber, Button, Space, Switch } from 'antd';
import type { PlanResponse } from '@aid/shared';

interface PlanFormProps {
  mode: 'create' | 'edit';
  initialValues?: PlanResponse | null;
  onSubmit: (values: Record<string, unknown>) => void;
  loading?: boolean;
}

export function PlanForm({ mode, initialValues, onSubmit, loading }: PlanFormProps) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        nombre: initialValues.nombre ?? '',
        precio: initialValues.precio ? Number(initialValues.precio) : undefined,
        comision: initialValues.comision ? Number(initialValues.comision) : undefined,
        generaComision: initialValues.generaComision,
        comentarios: initialValues.comentarios ?? '',
      });
    }
  }, [initialValues, form]);

  const handleFinish = (values: Record<string, unknown>) => {
    const payload: Record<string, unknown> = { ...values };
    if (payload.precio !== undefined) payload.precio = Number(payload.precio).toFixed(2);
    if (payload.comision !== undefined && payload.comision !== '') {
      payload.comision = Number(payload.comision).toFixed(2);
    } else {
      delete payload.comision;
    }
    onSubmit(payload);
  };

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={handleFinish}
      style={{ maxWidth: 600, width: '100%' }}
    >
      <Form.Item
        name="nombre"
        label="Name"
        rules={[{ required: true, message: 'Name is required' }]}
      >
        <Input />
      </Form.Item>
      <Form.Item name="precio" label="Price">
        <InputNumber min={0} step={0.01} precision={2} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="comision" label="Commission">
        <InputNumber min={0} step={0.01} precision={2} style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="generaComision" label="Generates Commission" valuePropName="checked">
        <Switch />
      </Form.Item>
      <Form.Item name="comentarios" label="Comments">
        <Input.TextArea rows={3} />
      </Form.Item>
      <Form.Item>
        <Space wrap size={[8, 8]}>
          <Button type="primary" htmlType="submit" loading={loading}>
            {mode === 'create' ? 'Create Plan' : 'Save Changes'}
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
}
